export function checkPasswordStrength(password) {    
    const minimumScore = 3;
    const minimumLength = 8;
    let characterScore = 0;
    let capitalScore = 0;
    let lowerCaseScore = 0;
    let numberScore = 0;
    let specialCharsScore = 0;

    const upperCaseReg = new RegExp('[A-Z]');
    const lowerCaseReg = new RegExp('[a-z]');
    const numbersReg = new RegExp('[0-9]');
    const specialCharsReg = new RegExp('([!,%,&,@,#,$,^,*,?,_,~,�,+])');

    characterScore = password.length >= minimumLength ? 1 : -1;
    capitalScore = password.match(upperCaseReg) ? 1 : 0;
    lowerCaseScore = password.match(lowerCaseReg) ? 1 : 0;
    numberScore = password.match(numbersReg) ? 1 : 0;
    specialCharsScore = password.match(specialCharsReg) ? 1 : 0;

    let totalScore = characterScore + capitalScore + lowerCaseScore + numberScore + specialCharsScore;

    if (!password.length) {totalScore = -1;}

    const strength = { score: totalScore, pass: totalScore >= minimumScore };
    return strength;
}

export function formatLocation(city, region, country) {
    const getCountry = () => {
        if(country === 'United States') {
            return 'USA';
        }
        else if(country === 'United Kingdom') {
            return 'UK';
        }
        else {
            return country;
        }
    }
    let location = city;
    if(region) {
        location += `, ${region}`;
    }
    if(country) {
        location += `, ${getCountry()}`;
    }
    return location;
}